import React, { useRef, useEffect, useState } from 'react';

import { motion } from "framer-motion";

import consts from '../libs/consts';

import Timer from "./Timer";

export default function Input(props) {

    const { 
        refs,
        className, 
        placeholder, 
        type="text", 
        name, 
        maxlength, 
        value, 
        setValue, 
        onChange,
        valid, 
        label, 
        error,
        setError, 
        success, 
        readOnly, 
        disabled,
        onBlur,
        onKeyDown,
        withButton, 
        withButtonPress,
        withText,
        size,
        index,
        subIndex=null,
        full,
        help,
        search,
        style,
        autoComplete="one-time-code",
        timer=false,
        timerState,
    } = props;

    const inputRef = useRef(null);

    const [classList, setClassList] = useState([]);

    const [t, setT] = useState(timer);
    const [f, setF] = useState(false);

    const [isOpenPost, setIsOpenPost] = useState(false);

    useEffect(() => {

        setT(timer);

    }, [timer]);

    useEffect(() => {

        if(setError) {
            setError({ ...error, [name]: "" });
        }

    }, [value])

    useEffect(() => {

        let arr = [];

        if(readOnly) arr.push("disable");
        if(withButton) arr.push("withButton");
        if(withText) arr.push("withText");
        if(search) arr.push("withSearch");
        if(error?.[name]) arr.push("error")
        if(className) arr.push(className);
        
        setClassList(arr);

    }, [readOnly, withButton, withText, search, className, error, name])

    const handleFocus = () => {
        setF(true);

        if(withButton === "주소찾기") {
            setIsOpenPost(true);
        }

    };

    const handleBlur = () => {
        setF(false);

        if(onBlur) onBlur();
    }

    const handleChange = (e) => {
        
        if(valid === 'num') {
            const num = e.target.value.replace(/\D/g, "")*1;
            console.log('valid', num + '/' + valid);

            if(onChange) {
                onChange(index, e, num, subIndex);
            } else {
                setValue(num);
            }

        } else if(valid === 'float') {
            const num = e.target.value.replace(/[^0-9.]/g, "");
            console.log('valid', num + '/' + valid);

            if(onChange) {
                onChange(index, e, num, subIndex);
            } else {
                setValue(num);
            }

        } else {

            if(onChange) {
                onChange(index, e, e.target.value, subIndex);
            } else {
                setValue(e.target.value);
            }
            
        }
    };

    const withButtonFunc = () => {
        if(withButton === '복사') {
            navigator.clipboard.writeText(value);
        } else if(withButton === "주소찾기") {
            setIsOpenPost(true);
        }
    }
    

    return (
        <div className={`input_box ${size ? 'input_box_'+size : ''}`} style={style}>
            {label && <label className="input_label" htmlFor={name}>{label}</label>}

            <div className={`input_section`}>
                <input 
                    ref={refs || inputRef}
                    type={type} 
                    name={name} 
                    id={name} 
                    className={classList?.join(" ")} 
                    placeholder={placeholder} 
                    onChange={handleChange} 
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onKeyDown={(e) => {onKeyDown && onKeyDown(e)}}
                    value={value}
                    maxLength={maxlength ? maxlength : "255"} 
                    readOnly={readOnly} 
                    disabled={disabled}
                    autoComplete={autoComplete}
                />    
                {withButton && 
                    <button type="button" className="input_with_button" onClick={() => { withButtonFunc(); withButtonPress && withButtonPress() }}>{withButton}</button>
                }
                {withText &&
                    <span className="input_with_text">{withText}</span>
                }
                
                { t ? (
                    <Timer timeOut={timerState}/>
                ) : (!disabled && !readOnly )&& (
                    <motion.div 
                        className={`clear_btn`}
                        initial={consts.loaderVariants.closed}
                        animate={(value && f && !readOnly) ? "open" : "closed"}
                        variants={consts.loaderVariants}
                        onClick={() => {
                            let e = { target: {name: name, value: ''} };
                            handleChange(e);
                        }}
                    />
                )}

                
                    
            </div>

            {error?.[name] && 
                <p className="input_error animate__animated animate__headShake">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 6.5V4.25M6 8.16772V8.1875M10.5 6.5C10.5 8.98528 8.48528 11 6 11C3.51472 11 1.5 8.98528 1.5 6.5C1.5 4.01472 3.51472 2 6 2C8.48528 2 10.5 4.01472 10.5 6.5Z" stroke="#FF5757" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                    <span>{error?.[name]}</span>
                </p>
            }
            {success && 
                <p className="input_success">{success}</p>    
            }
            {help && 
                help
            }
        </div>
    )    
}